import Loading from "@/components/Loading";
import { createApp } from "vue";

let $vm;
const loading = {};

loading.install = function (app) {
  if (!$vm) {
    const loading = createApp(Loading);
    $vm = loading.mount(document.createElement("div"));
    document.body.appendChild($vm.$el);
  }

  $vm.isShow = false;

  let loading = {
    show() {
      $vm.isShow = true;
    },
    hide() {
      $vm.isShow = false;
    },
  };

  if (!app.$loading) {
    app.$loading = loading;
  }

  app.config.globalProperties.$loading = app.$loading;
};

export default loading;
